import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TenantBusinessPlans, TenantConfigRes, TENANT_BUSINESS_PLANS } from 'app/components/models/tenant';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ConfigDataService } from 'app/services/config.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-create-config',
  templateUrl: './create-config.component.html',
  styleUrls: ['./create-config.component.css']
})
export class CreateConfigComponent implements OnInit {

  submitted = false;
  formValid = false;
  error = false;
  success = false;
  dataJSON: any;
  createTenantForm: FormGroup;
  planList: TenantBusinessPlans[] = [];
  dnsExists: boolean = false;
  tenantExists: boolean = false;
  configList: TenantConfigRes[] = [];

  constructor(
    private commonUtilService: CommonUtilService,
    private configService: ConfigDataService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    this.planList = TENANT_BUSINESS_PLANS;

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.TENANT");

    this.createTenantForm = this.createTenantFormBuilder(this.formBuilder);

    this.getConfigList();
  }

  createTenantFormBuilder(formBuilder: FormBuilder) {
    return formBuilder.group({
      name: ['', [Validators.required]],
      dns: ['', [Validators.required]],
      businessPlan: [this.planList[1].plan_it]
    });
  }

  get f() { return this.createTenantForm.controls; }

  get val() { return this.createTenantForm.value; }

  goToTenantList() {
    this.spinnerService.start();
    this.router.navigate(['/tenant/lista-tenant']);
  }

  getConfigList() {
    this.configService.getConfigList().subscribe(data => {
      this.configList = data;
      console.log(this.configList);
      this.spinnerService.stop();
    });
  }

  dnsCheck(searchValue: string): void {
    this.spinnerService.start();
    this.dnsExists = false;
    this.configList.forEach((e, i) => {
      if (searchValue === e.dns) {
        this.dnsExists = true;
      }
    });
    this.spinnerService.stop();
  }

  tenantCheck(searchValue: string): void {
    this.spinnerService.start();
    this.tenantExists = false;
    this.configList.forEach((e, i) => {
      if (searchValue === e.name) {
        this.tenantExists = true;
      }
    });
    this.spinnerService.stop();
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.success = false;
    this.error = false;

    if (this.createTenantForm.invalid) {
      this.commonUtilService.findInvalidControls(this.createTenantForm);
      this.error = true;
      this.spinnerService.stop();
      return;
    }

    this.dataJSON = {
      name: this.val.name,
      dns: this.val.dns,
      businessPlan: this.val.businessPlan
    };

    this.configService.addNewTenantConfig(this.dataJSON).subscribe(data => {
      this.success = true,
        setTimeout(() => { this.goToTenantList(); }, 2000);
    }, err => {
      this.error = true;
      this.spinnerService.stop();
      setTimeout(()=>{                           
        this.error = false;
      }, 2000); 
    });
    this.formValid = true;
  }

}
